import { useMemo } from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { useGroups } from "../../../General/OrganisationLevelGroups/context";
import { renderSettingsResourceLabel } from "../../../../../utils/helpers/settings";

const columnHelper = createColumnHelper();

export const useColumns = () => {
    const { t } = useTranslation();
    const { allocatedGroups } = useGroups();

    return useMemo(() => {
        const columns: any[] = [
            columnHelper.accessor("name", {
                header: t("name"),
                // alwaysVisible: true,
            }),
            columnHelper.accessor("job", {
                header: t("job")
            }),
            columnHelper.accessor("location", {
                header: t("location"),
            }),
        ];

        if (allocatedGroups.length > 0) {
            allocatedGroups.map((group: any) => 
                columns.push(columnHelper.accessor(group.level.replaceAll("_", ""), {
                    header: renderSettingsResourceLabel(group)
                }))
            )
        }
        return columns;
    }, [allocatedGroups, t]);
}
